/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ContinueInputs */

const en_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const ar_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إستمر`)
};

const de_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const es_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const it_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const ja_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

const ko_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

const pt_br_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const ru_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const th_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดำเนินการต่อ`)
};

const tr_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam Et`)
};

const zh_cn_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_tw_btn_continue = /** @type {(inputs: Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Btn_ContinueInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_continue = /** @type {((inputs?: Btn_ContinueInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ContinueInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_continue(inputs)
	if (locale === "ar") return ar_btn_continue(inputs)
	if (locale === "de") return de_btn_continue(inputs)
	if (locale === "es") return es_btn_continue(inputs)
	if (locale === "fr") return fr_btn_continue(inputs)
	if (locale === "it") return it_btn_continue(inputs)
	if (locale === "ja") return ja_btn_continue(inputs)
	if (locale === "ko") return ko_btn_continue(inputs)
	if (locale === "pt_br") return pt_br_btn_continue(inputs)
	if (locale === "ru") return ru_btn_continue(inputs)
	if (locale === "th") return th_btn_continue(inputs)
	if (locale === "tr") return tr_btn_continue(inputs)
	if (locale === "zh_cn") return zh_cn_btn_continue(inputs)
	return zh_tw_btn_continue(inputs)
});